export function setDateWithOffset(
  years: number,
  months: number,
  days: number
): Date {
  const date = new Date();
  date.setDate(date.getDate() + days);
  date.setMonth(date.getMonth() + months);
  date.setFullYear(date.getFullYear() + years);
  return date;
}

export function setStartDateWithOffset(
  years: number,
  months: number,
  days: number,
  startdate: Date
): Date {
  const date = new Date();
  const today = new Date();
  date.setDate(date.getDate() + days);
  date.setMonth(date.getMonth() + months);
  date.setFullYear(date.getFullYear() + years);
  return date > startdate ? date : startdate > today ? today : startdate ;
}

export function getEnumKeyByName(enumObject: any, name: string) {
  for (const enumMember in enumObject) {
      if (enumObject[enumMember] === name) {
          return enumMember;
      }
  }
}

/**  Removes most of the ASCII control characters */ 
export function replaceSpecialCharacters(obj: Object): Object {
  const formFields = Object.keys(obj);
  formFields.forEach(key => {
    if (typeof obj[key] === "object" && obj[key]) {
      replaceSpecialCharacters(obj[key]);
    } else {
      if (typeof obj[key] === "string" && obj[key]) {
        obj[key] = (obj[key] as string).subSpecialCharacters();
      }
    }
  });
  return obj;
}
